import React, { useContext } from "react";
import dynamic from "next/dynamic";

import { getModuleComponent } from "~components/modules/module";
import PersonalizedModule from "~components/modules/personalizedModule";
import PersonalizedModuleShadow from "~components/modules/personalizedModule/personalizedModuleShadow";
import type { ModuleRenderingProps } from "~components/shared/zones/utility";
import { PageContext } from "~context/PageContext";
import type { VariationComponent } from "~types/types";

const AbbaModule = dynamic(() =>
    import("~components/modules/abbaModule").then((module) => module.default)
);

interface ZoneModuleProps {
    module: VariationComponent;
    preview: boolean;
    renderingData: ModuleRenderingProps;
}

const ZoneModule = ({ module, preview, renderingData }: ZoneModuleProps) => {
    const { isModulePreview } = useContext(PageContext);

    const isAbbaModule =
        !preview &&
        Boolean(module.abbaConfigKey) &&
        Boolean(module.abbaTestVariants?.length);

    if (isAbbaModule) {
        return (
            <AbbaModule
                initialModule={module}
                preview={preview}
                renderingData={renderingData}
            />
        );
    }

    const isAutofillModule = Boolean(
        module.autofillData && module.type !== "pulse" && module.type !== "user"
    );

    if (isAutofillModule) {
        return module.duplicateOf ? (
            <PersonalizedModuleShadow
                module={module}
                preview={preview}
                renderingData={renderingData}
                duplicateOf={module.duplicateOf}
            />
        ) : (
            <PersonalizedModule
                module={module}
                preview={preview}
                renderingData={renderingData}
            />
        );
    }

    return getModuleComponent(module, preview, isModulePreview);
};

export default ZoneModule;
